import type { ImportAction } from "@/pages/human-resources/time-management/components/schedule-import/model/ImportAction.ts";
import { copyPreviousMonthSchedule } from "@/pages/human-resources/time-management/endpoints/schedules-copy/SchedulesCopyEndpoints.ts";
import useScheduleReferenceData from "@/pages/human-resources/time-management/schedules/reference-provider/useScheduleReferenceData.ts";
import useVisibleEmployeesSchedules from "@/pages/human-resources/time-management/model/schedule-view/useVisibleEmployeesSchedules.ts";
import useScheduleDataStateDispatch from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/useScheduleDataStateDispatch.ts";
import useSchedulesManager from "@/pages/human-resources/time-management/schedules/site-schedule/model/schedule-data/useSchedulesManager.ts";
import showErrorToast from "@/shared/components/generic/snackbar/showErrorToast.ts";
import { useTranslation } from "react-i18next";

export default function useImportPreviousMonthSchedules(): (
  action: ImportAction,
  matchWeekDays: boolean,
) => Promise<void> {
  const { t } = useTranslation(["humanResources"], {
    keyPrefix: "timeManagement",
  });
  const refData = useScheduleReferenceData();
  const dataStateDispatch = useScheduleDataStateDispatch();
  const visibleSchedules = useVisibleEmployeesSchedules();
  const {
    contractsManager: { startDate },
  } = useSchedulesManager();

  return async (
    action: ImportAction,
    matchWeekDays: boolean,
  ): Promise<void> => {
    const overwrite = action === "overwrite";
    const employeesIds = visibleSchedules.map((es) => es.employee.id);
    dataStateDispatch({
      type: "employeesMarkStale",
      employeesIds,
    });
    try {
      await copyPreviousMonthSchedule({
        siteId: parseInt(refData.siteData.siteId),
        overwrite,
        employeesIds: employeesIds.map((id) => parseInt(id)),
        targetDate: startDate.toISOString(),
        matchWeekDays,
      });
    } catch (error) {
      console.error("Failed to import schedules", error);
      showErrorToast(t("errors.backend.schedules.import"));
    }
    dataStateDispatch({ type: "schedulesMarkStale" });
  };
}
